<template>
  <div class="header-container">
    <div class="header-bg"></div>
    <div class="header-content">
      <Logo />
      <Login class="login"/>
    </div>
  </div>
</template>

<script>
import Logo from './components/Logo'
import Login from './components/Login'
export default {
  name: 'Header',
  components: { Logo, Login },
  mixins: [],
 
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.header-container {
  overflow: hidden;
  width: 100%;
  height: 108px;
  .header-bg {
     background: rgba(77,77,77,1);
     height: 8px;
     width: 100%;
  }
}
.header-content {
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  padding: 20px 0px;
  box-sizing: content-box;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.login {
  margin-left: 150px;
}
</style>
